import { CSSTransition } from 'react-transition-group';
import { DomAttribute } from 'targus';
import { useEscapeKeyHandler } from '../../../common/hooks/keyboard/useEscapeKeyHandler';
import { OVERLAY_ANIMATION_DURATION } from '../../constants';
import { ShadeView } from '../styles';
import { useOverlay, OverlayOutput } from './OverlayContext';

export const OverlayArea = () => {
  const { activeId, clear } = useOverlay();

  useEscapeKeyHandler(activeId ? clear : undefined);

  const handleClick: DomAttribute<'div', 'onClick'> = ev => {
    if (ev.target === ev.currentTarget) {
      clear();
    }
  };

  return (
    <CSSTransition in={Boolean(activeId)} unmountOnExit timeout={OVERLAY_ANIMATION_DURATION}>
      <ShadeView onClick={handleClick}>
        <OverlayOutput />
      </ShadeView>
    </CSSTransition>
  );
};
